import { useSearchParams } from 'react-router-dom';

import { c } from 'ttag';

import { AppName, appUrl } from '@freelancelabs/shared';

export interface ReturnTarget {
    href: string;
    label: string;
}

// Callers name their origin (?from=hub-admin, else the portal); the value travels, it is not
// deduced. Default is the portal.
export const useReturnTarget = (): ReturnTarget => {
    const [searchParams] = useSearchParams();
    const isBackOffice = searchParams.get('from') === 'hub-admin';

    return {
        href: appUrl(isBackOffice ? AppName.CLIENT_BO : AppName.PORTAIL_CLIENT),
        label: isBackOffice ? c('Account back').t`Back to the back-office` : c('Account back').t`Back to the portal`,
    };
};
